import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Model } from './../../models/clux/model-legacy';
import { FiltersCategory } from './filters.base';
import { MatButton } from '@angular/material/button';
import { FiltersCheckboxComponent } from './filters-checkbox/filters-checkbox.component';
import { FiltersDatesComponent } from './filters-dates/filters-dates.component';

@Component({
  selector: 'app-filters-dynamic',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton, FiltersCheckboxComponent, FiltersDatesComponent],
})
export class FiltersComponent {
  @Input() public category: FiltersCategory[];
  @Input() public activeObj: Model.FilterFlag;
  @Input() public rightJustify: boolean;

  @Output() public categoryFilterChanged = new EventEmitter<Model.FilterOption<Model.CategoryOptions[]>>();
  @Output() public dateFilterChanged = new EventEmitter<Model.FilterOption<Model.DateOptions>>();

  public openPopup(item: Model.Category): void {
    this.category.forEach((c) => {
      c.active = c.name === item.name;
    });
  }

  public isCheckBox(category: FiltersCategory): boolean {
    return category.type === 'checkBox';
  }

  public isDateSelection(category: FiltersCategory): boolean {
    return category.type === 'date';
  }

  public apply(filters?: Model.CategoryOptions[], category?: FiltersCategory): void {
    category.active = false;
    if (filters) {
      if (filters.length) {
        filters.forEach((f) => {
          const item = category.data.find((c) => f.name === c.name);
          if (item) {
            item.checked = f.checked;
          }
        });
      } else {
        category.data.forEach((f) => (f.checked = false));
      }
      const filtersSelected = {
        name: category.name,
        selectedOptions: filters,
      };
      this.categoryFilterChanged.emit(filtersSelected);
    }
  }

  public applyDateFilter(dateOption?: Model.DateOptions, category?: FiltersCategory): void {
    category.active = false;
    category.dates = dateOption;
    this.dateFilterChanged.emit({
      name: category.name,
      selectedOptions: category.dates,
    });
  }

  public isCategoryActive(category: FiltersCategory): boolean {
    if (category.type === 'checkBox') {
      return category.data?.some((o) => o.checked);
    }
    if (category.type === 'date') {
      return category.dates?.fromDate !== undefined || category.dates?.toDate !== undefined;
    }
  }
}
